import { getAuditsOperationDataSource } from './audits-operation.requests';
import { auditsOperationStore } from './audits-operation.store';

export class AuditsOperationQuery {
  store = auditsOperationStore;

  auditsOP$ = getAuditsOperationDataSource.data$();
}

export const auditsOperationQuery = new AuditsOperationQuery();
